import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import FormattedMessage from '../FormattedMessage';
export default function FormattedHTMLMessage(props) {
  return /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, props, {
    isHTML: true
  }));
}